import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Button } from 'uikit/buttons';

import styles from '../styles/filterToggleButton.module.scss';

const FilterToggleButton = ({
  isDisabled,
  name,
  onSelectionUpdate,
  options,
  param,
  selection,
}) => (
  <Button
    ariaLabel={options.find(({ value }) => value === selection)?.label || ''}
    aria-pressed={selection}
    className={classnames(styles.element, selection && styles.isActive)}
    disabled={isDisabled}
    onClick={() => {
      onSelectionUpdate({
        isToggle: true,
        isSelected: !selection,
        isSingleSelect: true,
        key: param,
        value: !selection,
      });
    }}
    size="small"
    text={name}
    variant="outlined"
  />
);

FilterToggleButton.defaultProps = {
  isDisabled: false,
  name: '',
  onSelectionUpdate: () => {},
  options: [],
  param: '',
  selection: false,
};

FilterToggleButton.propTypes = {
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  onSelectionUpdate: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  })),
  param: PropTypes.string,
  selection: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
};

export default React.memo(FilterToggleButton);
